<mat-dialog-content>
    <pixl-editor
        [htmlString]="data.explanationContentHtml"
        [editorHeight]="'auto'"
        [bearerToken]="data.authToken"
        [assetUrl]="data.assetUrl"
        [mediaUrl]="data.mediaUrl"
        [(editedHtmlString)]="data.explanationContentHtml"
    >
    </pixl-editor>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="onCancel()">Abbruch</button>
    <button mat-raised-button (click)="onSave()">Übernehmen</button>
</mat-dialog-actions>
